import styled from 'styled-components';
import Button from '@mui/material/Button';

import { ButtonLarge } from '../typography/typography';
import { theme } from '../../global-styles/colors';

const AlxButton = styled(Button)`
  width: 100%;
  .MuiIconButton-label {
    width: auto;
    max-height: 56px;
    img {
      width: 32px;
    }
  }

  &.MuiButtonBase-root {
    background-color: ${(props) => props.theme.primary.primary50};
    color: ${theme.neutrals.white};
    box-shadow: none;
    padding: 18px 24px;
    height: 56px;
    min-width: 56px;
    ${ButtonLarge};
    .MuiIconButton-root {
      border-radius: 6px;
    }

    &.MuiButton-root {
      text-transform: none;
    }
    .MuiTouchRipple-root {
      display: none;
    }
    &:hover {
      background-color: ${(props) => props.theme.primary.primary50};
    }
  }

  &.secondary {
    background-color: ${theme.neutrals.white};
    color: ${(props) => props.theme.primary.primary50};
    border: 1px solid ${(props) => props.theme.primary.primary50};
    &:hover {
      background-color: ${(props) => props.theme.primary.primary50};
      color: ${theme.neutrals.white};
    }
    &.Mui-disabled {
      border: 1px solid rgba(0, 0, 0, 0.26);
    }
  }

  &.ghost {
    background-color: transparent;
    color: ${(props) => props.theme.primary.primary50};
    border: none;
    padding: 0;
    box-shadow: none;
    min-height: unset;
    width: auto;
    min-width: 0;
    &:hover {
      background-color: transparent;
      color: ${(props) => props.theme.primary.primary50};
    }
    &.Mui-disabled {
      border: 1px solid rgba(0, 0, 0, 0.26);
    }
  }

  &.danger {
    color: ${theme.status.error.medium};
    font-size: 18px;
  }

  &.circle {
    border-radius: 100%;
    width: 128px;
    height: 128px;
    border: 1px solid white;
    display: flex;
    align-items: center;
    justify-content: center;

    &.hightlight {
      color: ${(props) => props.theme.primary.primary50};
      background-color: white;
    }
  }
  &.borderWhite {
    border: 1px solid white;
  }
`;

export default AlxButton;
